import { h, Component, Fragment, options, isValidElement } from 'preact';
import FilterComponent from './filter.component';

export default class YearFilterComponent extends Component {
    constructor() {
        super();
        this.state = {
            years: [],
            previousDataType: '',
            allOption: { id: 'ALL', label: 'All' }
        };
    }

    static getDerivedStateFromProps(props, state) {
        // console.log('%cTRACE: getDerivedStateFromProps', 'color: green; font-weight: 900; background: white')
        if (props.selectedDataType.id !== state.previousDataType.id) {
            state.years = [];
            state.previousDataType = props.selectedDataType;

            if (props.selectedDataType) {
                state.years = [state.allOption, ...props.selectedDataType.years];
            }
            return state;
        }

        return null;
    }

    isAll() {
        // console.log('%cTRACE: isAll', 'color: green; font-weight: 900; background: white')
        return this.state.years.length > 0 &&
            this.state.years.filter(y => y.id !== this.state.allOption.id).every(y => this.props.selectedYears.includes(y));
    }

    displayAll() {
        // console.log('%cTRACE: displayAll', 'color: green; font-weight: 900; background: white')
        // year component needs to be able to mask selected years with an extra 'ALL' option
        if (this.isAll()) {
            return [this.state.allOption];
        }
        return this.props.selectedYears;
    }

    onSelect(option) {
        // console.log('%cTRACE: onSelect', 'color: green; font-weight: 900; background: white')
        const index = this.props.selectedYears.findIndex(x => option.id === x.id);
        if (index < 0) {
            // selecting an option
            if (option.id === this.state.allOption.id) {
                this.props.updateSelectedYears([...this.state.years.filter(y => y.id !== this.state.allOption.id)]);
            }
            else {
                this.props.updateSelectedYears([...this.props.selectedYears, option]);
            }
        }
        else if (option.id !== this.state.allOption.id) {
            // deselecting an option
            if (this.isAll()) {
                // since all was selected, deselect everything except the selected option
                this.props.updateSelectedYears([option]);
            }
            else {
                // otherwise simply deselect the clicked option
                this.props.updateSelectedYears([...this.props.selectedYears.filter(y => y.id !== option.id)]);
            }
        }
    }

    render() {
        const self = this;
        return (
            <Fragment>
                <FilterComponent
                    options={self.state.years}
                    onSelect={(option) => self.onSelect(option)}
                    selected={self.displayAll()}
                    message="Select Years"
                    ga="QR Menu: Year"
                />
            </Fragment>
        );
    }
}
